<div class="Picklist" *ngIf="(fixedcutterSapData | async) as request">
  <div style="padding: .5rem .75rem;border-radius: 8px;background: #8b8b8b4f;border: dashed;">
    <div kendoTypography variant="p">
      <i>Note: If any modifications are made to the model after generating the SAP data, please regenerate the data to
        ensure accuracy and consistency.</i>
      <button kendoButton themeColor="info" (click)="generateSapData()">(Re)Generate Data</button>
    </div>
  </div>
  <form [formGroup]="appPopulateSapData" class="k-form">
    <kendo-panelbar>
      <kendo-panelbar-item title="Bit Information">
        <ng-template kendoPanelBarItemTitle>
          <span>Bit Information</span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div style="margin-left: 15px; margin-right: 15px;">
            <div class="row">
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="Profile">Profile:</label>
                <kendo-textbox placeholder="Enter Profile" [readonly]="true" name="Profile"
                  formControlName="cutterProfileShape"></kendo-textbox>
                <kendo-formhint style="color:darkcyan;">Pulled from the model</kendo-formhint>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="Profile">Cutter Density:</label>
                <kendo-textbox formControlName="cutterDensity" placeholder="Enter Cutter Density" name="CutterDensity"
                  required></kendo-textbox>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="pwd">Makeup Length:</label>
                <kendo-textbox formControlName="bitMakeUpLength" placeholder="Enter Bit Make-up" name="BitMake-up"
                  required></kendo-textbox>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="pwd">Shank Diameter:</label>
                <kendo-textbox formControlName="shankDiameter" placeholder="Enter Shank Diameter" name="ShankDiameter"
                  required></kendo-textbox>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="hw">Height/Width:</label>
                <kendo-textbox formControlName="heightToWidthRatio" placeholder="Enter H/W" name="hw"
                  [readonly]="true"></kendo-textbox>
                <kendo-formhint style="color:darkcyan;">Pulled from the model</kendo-formhint>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="PadAngle">Pad Angle:</label>
                <kendo-textbox formControlName="padAngle" placeholder="Enter Pad Angle" name="PadAngle"
                  [readonly]="true"></kendo-textbox>
                <kendo-formhint style="color:darkcyan;">Pulled from the model</kendo-formhint>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="jsa">Junk Slot Area:</label>
                <kendo-textbox formControlName="junkSlotArea" placeholder="Enter Junk Slot Area" name="JunkSlotArea"
                  required></kendo-textbox>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="nfv">Nrml Face Volume:</label>
                <kendo-textbox formControlName="normalizedFaceVolume" placeholder="Enter Normalized Face Volume"
                  name="nfv" required></kendo-textbox>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="trac">Track Set:</label><br />
                <kendo-checkbox formControlName="isTrackSet" [disabled]="true" name="trac"></kendo-checkbox>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label class="control-label" for="mfld">MLFB:</label><br />
                <kendo-checkbox formControlName="multiLevelForceBalance" [disabled]="true"
                  name="MultiLevelForceBalance"></kendo-checkbox>
                <kendo-formhint style="color:darkcyan;">Pulled from the model</kendo-formhint>
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2" *ngIf="request.bodyType == 'STEEL'">
                <label class="control-label" for="PieceSteel">One Piece Steel:</label><br />
                <kendo-checkbox formControlName="onePiece" [disabled]="true" name="PieceSteel"></kendo-checkbox>
                <kendo-formhint style="color:darkcyan;">Pulled from the model</kendo-formhint>
              </div>
            </div>
            <kendo-panelbar *ngIf="request.hasSleeve">
              <kendo-panelbar-item title="Sleeve Information">
                <div class="row">
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <label class="control-label" for="Sleeve">Sleeve Length:</label>
                    <kendo-textbox formControlName="sleeveLength" placeholder="Enter Sleeve Length" required>
                    </kendo-textbox>
                  </div>
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <label class="control-label" for="gaugeTypeselect">Gauge Type:</label>
                    <kendo-dropdownlist textField="bomSleeveGaugeType" valueField="BomSleeveGaugeType"
                      [valuePrimitive]="true" formControlName="SleeveGauge" placeholder="Select Gauge Type" required>
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <label class="control-label" for="SleeveType">Sleeve Type:</label>
                    <kendo-dropdownlist textField="BomSleeveType" valueField="BomSleeveType" [valuePrimitive]="true"
                      formControlName="sleeveType" placeholder="Select Sleeve Type" required>
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <label class="control-label" for="SleeveExposure">Sleeve Exposure:</label>
                    <kendo-dropdownlist textField="BomSleeveExposure" valueField="BomSleeveExposure"
                      [valuePrimitive]="true" formControlName="sleeveExposure" placeholder="Select Sleeve Exposure"
                      required>
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <label class="control-label" for="SleeveGuage">Sleeve Gauge:</label>
                    <kendo-dropdownlist textField="BomSleeveGauge" valueField="BomSleeveGauge" [valuePrimitive]="true"
                      formControlName="sleeveGaugeDrawingNumber" placeholder="Select Sleeve Gauge" required>
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <label class="control-label" for="Rough">Rough Length:</label>
                    <kendo-textbox formControlName="roughLength" placeholder="Enter Rough Length" required>
                    </kendo-textbox>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-6 col-md-4 col-lg-2">
                    <kendo-checkbox formControlName="cuttersOnSleeve">
                    </kendo-checkbox>
                    <label class="control-label" for="CuttersonSleeve">Cutters on Sleeve</label>
                  </div>
                </div>
              </kendo-panelbar-item>
            </kendo-panelbar>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item title="SAP Information">
        <ng-template kendoPanelBarContent>
          <div style="margin: 15px;">
            <app-sap-part-numbers [request$]="request$"
              [fixedCutterSapData$]="fixedcutterSapData"></app-sap-part-numbers>
            <kendo-card width="100%" style="margin-bottom: 15px;">
              <kendo-card-header>Router</kendo-card-header>
              <kendo-card-body></kendo-card-body>
            </kendo-card>
            <kendo-card width="100%" style="margin-bottom: 15px;">
                <kendo-card-header>
                  <div class="sap-part-numbers__header">
                    <div class="sap-part-numbers__titles">
                      <div class="k-card-title">Bill of Materials</div>
                      <div class="k-card-subtitle">Generated bill of materials pulled from model and RTA</div>
                    </div>
                    <kendo-buttongroup>
                      <button kendoButton themeColor="primary" title="Create documents in SAP"
                        (click)="pushBOMToSAP()">Push to SAP</button>
                      <button kendoButton themeColor="info" title="Save BOM changes to the database"
                        (click)="saveBOM()">Save BOM</button>
                    </kendo-buttongroup>
                  </div>
                </kendo-card-header>
                <kendo-card-body>
                  <div class="form-group col-lg-12" *ngFor="let layout of rtaBomLayout$ | async">
                    <app-partelement-data [partTitle]="layout.name" [partKey]="layout.pickListName"
                      [picklistOptions]="processPicklistData(layout.data)" [elementsData$]="getBomItemByType(layout.id)"
                      [isModelDriven]="layout.isModelDriven" [isMultiRow]="layout.isMultiRow" [canAddRow]="layout.canAddRow"
                      [isRTADriven]="layout.isRTADriven"
                      (elementsUpdated)="onElementsUpdated($event)"></app-partelement-data>
                  </div>
                </kendo-card-body>
              </kendo-card>
            <kendo-card width="100%">
              <kendo-card-header>
                <div class="sap-part-numbers__header">
                  <div class="sap-part-numbers__titles">
                    <div class="k-card-title">Drawings/Documents</div>
                    <div class="k-card-subtitle">Generated document numbers appear here once available.</div>
                  </div>
                  <kendo-buttongroup>
                    <button kendoButton themeColor="primary" title="Create documents in SAP"
                      (click)="processRTADrawings()">Push to SAP</button>
                    <button kendoButton themeColor="warning" title="Imports documents from SAP"
                      (click)="importFromSAP()">Import from SAP</button>
                  </kendo-buttongroup>
                </div>
              </kendo-card-header>
              <kendo-card-body>
                <app-sapdocuments-data [HardFacingDetailLookUp]="HardFacingDetailLookUp"
                  [BomMaskingDetail]="BomMaskingDetail" [BomSacrificalDetail]="BomSacrificalDetail"
                  [AngleBoxDetail]="AngleBoxDetail" [GaugeByBitSize]="GaugeByBitSize"
                  [HardFacingSleeveLookup]="HardFacingSleeveLookup" [BomMaskingSleeve]="BomMaskingSleeve"
                  [BomSacrificalSleeve]="BomSacrificalSleeve" [draftId]="draftId">
                </app-sapdocuments-data>
                <fv-document-links *ngIf="partId" [partId]="partId" [canEdit]="true" [rtaNum]="draftId"
                  style="margin-top: 15px;"></fv-document-links>
              </kendo-card-body>
            </kendo-card>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item title="Marketing Sheet Information">
        <ng-template kendoPanelBarContent>
          <div style="margin: 15px;">
            <app-marketingsheet-data [draftId]="draftId" [request$]="request$"
              [bitFeatureIds]="getBitFeatureIds((request$ | async))">
            </app-marketingsheet-data>
          </div>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </form>

</div>

<!-- Import from SAP Modal Dialog -->
<kendo-dialog *ngIf="showImportDialog" (close)="closeImportDialog()" [minWidth]="700" [width]="900">
  <kendo-dialog-titlebar>
    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <span>Import BOM Items from SAP</span>
    </div>
  </kendo-dialog-titlebar>

  <div *ngIf="isLoadingBomItems" style="padding: 40px; text-align: center;">
    <kendo-loader type="infinite-spinner" size="large"></kendo-loader>
    <p style="margin-top: 20px;">Loading BOM items from SAP...</p>
  </div>

  <div *ngIf="!isLoadingBomItems && sapBomItems.length === 0 && !bomImportError"
    style="padding: 20px; text-align: center;">
    <p>No BOM items found for the selected material.</p>
  </div>

  <div *ngIf="bomImportError" style="padding: 20px;">
    <div class="k-notification k-notification-error" style="margin-bottom: 15px;">
      <div class="k-notification-content">
        <span class="k-icon k-font-icon k-i-error"></span>
        {{ bomImportError }}
      </div>
    </div>
  </div>

  <div *ngIf="!isLoadingBomItems && sapBomItems.length > 0" style="padding: 20px;">
    <p style="margin-bottom: 15px;">Select the BOM items you want to import into this RTA:</p>

    <kendo-grid [data]="sapBomItems" [selectable]="{ enabled: true, checkboxOnly: true, mode: 'multiple' }"
      [kendoGridSelectBy]="'itemNumber'" [(selectedKeys)]="selectedBomItems" [height]="400">

      <kendo-grid-checkbox-column [width]="45" [showSelectAll]="true"></kendo-grid-checkbox-column>

      <kendo-grid-column field="materialDescription" title="Description" [width]="250"></kendo-grid-column>
      <kendo-grid-column field="documentType" title="Doc Type" [width]="100"
        *ngIf="hasDocumentInfo"></kendo-grid-column>
      <kendo-grid-column field="docNumber" title="Doc Number" [width]="120" *ngIf="hasDocumentInfo"></kendo-grid-column>
      <kendo-grid-column field="documentVersion" title="Version" [width]="80"
        *ngIf="hasDocumentInfo"></kendo-grid-column>
      <kendo-grid-column field="documentPart" title="Part" [width]="80" *ngIf="hasDocumentInfo"></kendo-grid-column>
    </kendo-grid>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="closeImportDialog()">Cancel</button>
    <button kendoButton themeColor="primary" (click)="confirmImport()" [disabled]="selectedBomItems.length === 0">
      Import Selected ({{ selectedBomItems.length }})
    </button>
  </kendo-dialog-actions>
</kendo-dialog>